// Cadence suffix for a subscription's authored billing period (ADR-039).
// Deliberately duplicated from marketplace's commerce-state.ts rather than
// shared: two repos and three entries do not justify a package, and the
// wire value is an unconstrained string here, so this returns '' for
// anything unrecognised — including inherited Object.prototype keys like
// '__proto__' or 'constructor' — instead of rendering "undefined" (or,
// worse, an inherited object/function).
const SUFFIX: Record<string, string> = { monthly: '/mo', quarterly: '/qtr', annual: '/yr' };

export function periodSuffix(period: string | null): string {
  if (!period || !Object.hasOwn(SUFFIX, period)) return '';
  return SUFFIX[period] ?? '';
}
